const msConversionFactor = {
  "mins": 60000,
  "hours": 3600000,
  "days": 86400000,
  "weeks": 604800000
};

/**
 * Converts the given unit and amount into milliseconds
 * @param  {String} unitOfTime   Unit of Time
 * @param  {Number} amount Amount of Time
 * @returns {Number}
 */
export function convertToMS(unitOfTime, amount) {
  return msConversionFactor[unitOfTime] * amount;
}

/**
 * Converts milliseconds into the highest order of magnitude for time
 * @param  {Number} milliseconds in time
 * @returns {Object|Null}
 */
export function convertToUnitTime(milliseconds) {
  if (milliseconds < 0) {
    return null;
  }

  if (milliseconds === 0) {
    return ["mins", 0];
  }

  let result;
  Object.keys(msConversionFactor).forEach((unitOfTime) => {
    if (milliseconds % msConversionFactor[unitOfTime] === 0) {
      result = [unitOfTime, milliseconds / msConversionFactor[unitOfTime]];
    }
  });

  return result;
}
